import React, {memo} from 'react';

import {RouterProvider} from 'react-router-dom';

import useAPIObserver from '@/hooks/useAPIObserver';
import useDeviceHubObserver from '@/hooks/useDeviceHubObserver';
import useHubInitConnection from '@/hooks/useHubInitConnection';

import MainAlertMessage from './contents/main/MainAlertMessage';
import MainLoadingPage from './contents/main/MainLoadingPage';
import MainModal from './contents/main/MainModal';
import MainNumpadModal from './contents/main/MainNumpadModal';
import MainPopUp from './contents/main/MainPopUp';
import MainToast from './contents/main/MainToast';
import MainVirtualKeyboard from './contents/main/MainVirtualKeyboard';
import Router from './contents/Router';
import useAutoRefreshUpdateSW from './hooks/useAutoRefreshUpdateSW';
import useRouterLoader from './hooks/useRouterLoader';

import './App.scss';

function App() {
  useAPIObserver();
  useDeviceHubObserver();
  useHubInitConnection();
  useAutoRefreshUpdateSW();

  const loaders = useRouterLoader();

  return (
    <div
      className={`app ${process.env.NODE_ENV}-mode`}
      id="container"
    >
      <RouterProvider router={Router(loaders)} />
      {/*  FIXME: redundant component implementation MainPopUp === MainModal */}
      <MainPopUp />
      <MainModal />
      <MainNumpadModal />
      <MainVirtualKeyboard />
      <MainLoadingPage />
      {/*  FIXME: redundant component implementation MainAlertMessage === MainToast */}
      <MainAlertMessage />
      <MainToast />
    </div>
  );
}
export default memo(App);
